<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				PANEL DE CONTROL
			</template>

			<template v-slot:subtitle> 
				PANEL DE CONTROL
			</template>


			<template v-slot:content>

				<div id="dashboard">
					

					<!-- estadisticas -->
					<v-row v-if="estadisticas != null">

						<v-col md="4" sm="6" cols="12">
							<v-card light elevation="5" class="dash-card">
								<v-icon class="dash-card-icon">mdi-send-circle</v-icon>
								<h6 class="dash-card-title">ENVÍOS</h6>
								<span class="dash-card-number">{{estadisticas.envios}}</span>
							</v-card> 
						</v-col>

						<v-col md="4" sm="6" cols="12">
							<v-card light elevation="5" class="dash-card">
								<v-icon class="dash-card-icon">mdi-account</v-icon>
								<h6 class="dash-card-title">CLIENTES</h6>
								<span class="dash-card-number">{{estadisticas.clientes}}</span>
							</v-card> 
						</v-col>

						<v-col md="4" sm="6" cols="12">
							<v-card light elevation="5" class="dash-card">
								<v-icon class="dash-card-icon">mdi-post</v-icon>
								<h6 class="dash-card-title">POSTS PUBLICADOS</h6>
								<span class="dash-card-number">{{estadisticas.posts}}</span>
							</v-card> 
						</v-col>

					</v-row>


					<!-- welcome -->
					<div class="text-center">
						<v-icon id="dash-icon-welcome">mdi-account-group</v-icon>
						<h2 id="dash-text-welcome">¡Bienvenido(a)!</h2>
					</div>

				</div>

		  </template>

		</layout>

	</div>
</template>


<style>
	
	.dash-card {
		border-left: 10px solid gray !important;
		padding: 20px !important;
	}

	#dashboard {
		padding-left: 100px;
		padding-right: 100px;
		margin-top: 30px;
	}

	.dash-card-icon {
		font-size: 60px !important;
		color: #d0d0d0 !important;
		float: right !important;
		margin-top: -3px !important;
	}

	.dash-card-title {
		color:#989898
	}

	.dash-card-number {
		font-weight: bold;
		font-size: 24px;
		color: #989898;
	}

	#dash-icon-welcome {
		color: #989898 !important;
		font-size: 200px !important;
	}

	#dash-text-welcome {
		margin-top: -10px;
		margin-bottom: 10px;
		color:#989898
	}

	@media(max-width: 1024px) {

		#dashboard {
			padding-left: 50px;
			padding-right: 50px;
		}

	}

	@media(max-width: 320px) {

		#dashboard {
			padding-left: 20px;
			padding-right: 20px;
		}

	}

</style>


<script>
	
	import Layout from './../../layout/Layout'
	import SettingService from '@/shared/services/SettingService'


	export default
	{

		data() {
			return {
				estadisticas: null
			}
		},

		components: {
			Layout
		},

		created() {
			this.getEstadisticas()
		},

		methods: {

			async getEstadisticas()
			{
				const resp = await SettingService.getEstadisticas()
				this.estadisticas = resp.data
			}

		}

	}

</script>